import { useState } from "react";
import { ArrowLeft, Building2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { preconApi } from "../lib/api";
import { backToBidBoard, clearNewCustomerRequest } from "../lib/navigation";

/** Shown on Settings › Directory when the Bid Board sent us here to add a brand-new customer. */
export default function NewCustomerBanner({ request, company, onDismiss, compact = false }) {
  const [busy, setBusy] = useState(false);
  const finish = async () => {
    setBusy(true);
    try {
      await preconApi.addInvitation(request.job_id, { gc_name: company.name });
      toast.success(`${company.name} added to ${request.project_name}`);
      clearNewCustomerRequest(); onDismiss(); backToBidBoard();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not add the customer to the bid");
    } finally { setBusy(false); }
  };
  const cancel = () => { clearNewCustomerRequest(); onDismiss(); backToBidBoard(); };
  const sfx = compact ? "-drawer" : "";
  const buttons = (
    <span className="flex items-center gap-2">
      <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={cancel} data-testid={`new-customer-cancel${sfx}`}>
        <ArrowLeft className="mr-1 h-3 w-3" /> Back without adding
      </Button>
      <Button size="sm" className="h-7 text-xs" disabled={!company || busy} onClick={finish} data-testid={`new-customer-finish${sfx}`}>
        {busy ? <Loader2 className="mr-1 h-3 w-3 animate-spin" /> : null}Add to bid &amp; return
      </Button>
    </span>
  );
  if (compact) return buttons;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-[#007BFF]/30 bg-[#007BFF]/5 px-3 py-2 text-xs"
         data-testid="new-customer-banner">
      <Building2 className="h-4 w-4 text-[#007BFF]" />
      <span className="text-slate-700">
        Adding a new customer for <strong>{request.project_name}</strong>
        {company ? <> — <strong>{company.name}</strong> is saved. Add the contact in the drawer, then return.</>
                 : <>. Fill in the company, save it, then add the contact.</>}
      </span>
      <span className="ml-auto">{buttons}</span>
    </div>
  );
}
